import PostsList from "./posts-list";

export default PostsList;
